import {
	createSearchParams,
	useLocation,
	useNavigate,
	useParams,
	useSearchParams,
} from 'react-router-dom';
import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { KYC_PAGINATION_PARAMS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/constants';

interface Props {
	investorId: string;
	kycWorkflowId?: string;
	selectedInvestor?: string;
	reviewPaginatedInvestors?: boolean;
}

export const useNavigateToKycPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { dealId, mipId } = useParams();
	const [searchParams] = useSearchParams();

	const navigateToKycPage = ({
		investorId,
		kycWorkflowId,
		selectedInvestor,
		reviewPaginatedInvestors = false,
	}: Props) => {
		// Capture the current URL for navigation back
		const currentUrl = location.pathname + location.search;
		const searchParamsObj: Record<string, string> = {
			kycEntryPointUrl: currentUrl,
		};

		if (selectedInvestor) {
			searchParamsObj.selectedInvestor = selectedInvestor;
		}

		if (kycWorkflowId) {
			searchParamsObj.kycWorkflowId = kycWorkflowId;
		}

		const offsetParam = searchParams.get(KYC_PAGINATION_PARAMS.OFFSET_PARAM_KEY);
		const limitParam = searchParams.get(KYC_PAGINATION_PARAMS.LIMIT_PARAM_KEY);
		const search = searchParams.get(KYC_PAGINATION_PARAMS.SEARCH_QUERY_PARAM_KEY);

		if (search) {
			searchParamsObj[KYC_PAGINATION_PARAMS.SEARCH_QUERY_PARAM_KEY] = search;
		}

		if (offsetParam) {
			searchParamsObj[KYC_PAGINATION_PARAMS.OFFSET_PARAM_KEY] = offsetParam;
		}

		if (limitParam) {
			searchParamsObj[KYC_PAGINATION_PARAMS.LIMIT_PARAM_KEY] = limitParam;
		}

		if (reviewPaginatedInvestors) {
			searchParamsObj.reviewPaginatedInvestors = 'true';
		}

		const searchString = createSearchParams(searchParamsObj).toString();

		const kycPageUrl = mipManagePath(`${MIP_MANAGE_ROUTES.KYC_PAGE}/main/:investorId`, {
			mipId: mipId ?? '',
			dealId: dealId ?? '',
			investorId,
		});

		navigate({ pathname: kycPageUrl, search: searchString });
	};

	return { navigateToKycPage };
};
